import React from 'react';
import WIDGT_AIND_QUANT_01_Widget from './WIDGT_AIND_QUANT_01_Widget';
import WIDGT_AIND_QUANT_02_Widget from './WIDGT_AIND_QUANT_02_Widget';

const AreaIndicatorWidgetFactory = ({ widget, atPublicDashboard = false, password = null }) => {
    switch (widget.widgetConfig.acronym) {
        case 'WIDGT-AIND-QUANT-01':
            return <WIDGT_AIND_QUANT_01_Widget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        case 'WIDGT-AIND-QUANT-02':
            return <WIDGT_AIND_QUANT_02_Widget widget={widget} atPublicDashboard={atPublicDashboard} password={password} />;
        default:
            return <div>Unknown area indicator widget type</div>;
    }
};

export default AreaIndicatorWidgetFactory;